var _circle, _path, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00008,
    cy: 6.99984,
    r: 5.55008,
    stroke: "#505050",
    strokeWidth: 0.900012
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94967 6.99984C8.94967 8.61412 8.68712 10.0549 8.2789 11.0754C8.07429 11.5869 7.84191 11.9707 7.60689 12.2192C7.37277 12.4668 7.16741 12.5499 6.99964 12.5499C6.83187 12.5499 6.62652 12.4668 6.3924 12.2192C6.15737 11.9707 5.92499 11.5869 5.72038 11.0754C5.31216 10.0549 5.04962 8.61412 5.04962 6.99984C5.04962 5.38555 5.31216 3.94482 5.72038 2.92427C5.92499 2.41274 6.15737 2.02899 6.3924 1.78047C6.62652 1.53291 6.83187 1.44976 6.99964 1.44976C7.16741 1.44976 7.37277 1.53291 7.60689 1.78047C7.84191 2.02899 8.07429 2.41274 8.2789 2.92427C8.68712 3.94482 8.94967 5.38555 8.94967 6.99984Z",
    stroke: "#505050",
    strokeWidth: 0.900012
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3697_707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 12,
    height: 13
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00008,
    cy: 6.99984,
    r: 6.00008,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3697_707)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.00008,
    cy: -0.200114,
    r: 5.55008,
    stroke: "#505050",
    strokeWidth: 0.900012
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.00008,
    cy: 14.2,
    r: 5.55008,
    stroke: "#505050",
    strokeWidth: 0.900012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 7H12.3998",
    stroke: "#505050",
    strokeWidth: 0.900012
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.0537ca460b2e18658ec889877d20d761.svg";
export { ForwardRef as ReactComponent };